// @ts-nocheck
import { 
    CREATE_TUTORIAL_REQUEST,
    CREATE_TUTORIAL_SUCCESS,
    CREATE_TUTORIAL_FAILURE,
    FETCH_DEMO_VIDEOS_REQUEST,
    FETCH_DEMO_VIDEOS_SUCCESS,
    FETCH_DEMO_VIDEOS_FAILURE,
    UPDATE_DEMO_VIDEOS_REQUEST,
    UPDATE_DEMO_VIDEOS_SUCCESS,
    UPDATE_DEMO_VIDEOS_FAILURE,
    DELETE_DEMO_VIDEOS_SUCCESS,
    DELETE_DEMO_VIDEOS_FAILURE,
    DELETE_DEMO_VIDEOS_REQUEST
} from "../constants/tutorialVideoConfiguration";

const initialState = {
    tutorialConfiguration: [],
    videos: [],
    totalPages: 0,
    loading: false,
    error: null,
};

const tutorialVideoReducer = (state = initialState, action) => {
    switch (action?.type) {
        
        case CREATE_TUTORIAL_REQUEST:
            return {
                ...state,
                error: null, 
                tutorialConfiguration: []
            };
        case CREATE_TUTORIAL_SUCCESS:
            return {
                ...state,
                tutorialConfiguration: action.payload.data,
                error: null,
            };
        case CREATE_TUTORIAL_FAILURE:
            return {
                ...state,
                error: action.payload || "Failed to upload tutorial connfiguration", 
            }
        case FETCH_DEMO_VIDEOS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                
            }
        case FETCH_DEMO_VIDEOS_SUCCESS:
            return {
                ...state,
                loading: false,
                videos: action?.payload?.videos || [],
                totalPages: action?.payload?.totalPages || 0,
                error: null,
            };
        case FETCH_DEMO_VIDEOS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action?.payload || "Failed to fetch demo videos", 
            }
        case UPDATE_DEMO_VIDEOS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case UPDATE_DEMO_VIDEOS_SUCCESS:
            const updatedVideo = action?.payload?.video; 

            return {
                ...state,
                loading: false,
                videos: state?.videos?.map((v) =>
                v?._id === updatedVideo?._id ? updatedVideo : v
                ),
            };
        case UPDATE_DEMO_VIDEOS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case DELETE_DEMO_VIDEOS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,

            };
        case DELETE_DEMO_VIDEOS_SUCCESS:
            const deletedVideoId = action?.payload?.id || action?.payload?._id;
            return {
                ...state,
                loading: false,
                videos: state?.videos?.filter((v) => v?.id !== deletedVideoId),
            };
        case DELETE_DEMO_VIDEOS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action?.payload,
            };

        default:
            return state;
    }
};

export default tutorialVideoReducer;
export {
    initialState
}